<template>
<h2>Welcome Back</h2>
</template>

<script>
export default {
    name: 'callback',
    props: ['auth'],
    data () {
        this.auth.handleAuthentication()
        return {}
    }
}
</script>



// WEBPACK FOOTER //
// callback.vue?a05a4b24